import React from "react";
import style from "./Input.module.css";

interface inputType {
  onChange: (e: any) => void;
  type: string;
  id?: string;
  name?: string;
  value?: string | number;
  defaultValue?: any;
  styleInput: any;
  styleLabel?: any;
  styleContainer?: any;
  styleInputFor?: any;
  min?: number;
  max?: number;
  inputFor?: string;
  labelText?: string;
  errorText?: string;
  pattern?: any;
  placeHolder: string;
  isMandatory?: boolean;
  iconSearch?: boolean;
  onSubmit?: any;
}

function Input(props: inputType) {
  return (
    <div className={props.styleContainer}>
      <label className={props.styleLabel} htmlFor={props.name}>
        {props.labelText}{" "}
        <span style={{ marginBottom: "10px", color: "red" }}>
          {props.isMandatory ? "*" : ""}
        </span>
      </label>
      <input
        id={props.id}
        name={props.name}
        type={props.type}
        value={props.value}
        defaultValue={props.defaultValue}
        pattern={props.pattern ? props.pattern : ""}
        className={`${style.input} ${props.styleInput} ${
          props.errorText ? style.error : ""
        }`}
        onChange={props.onChange}
        placeholder={props.placeHolder}
        onSubmit={props.onSubmit}
        autoFocus={false}
      />
      <div className={props.styleInputFor}>{props.inputFor}</div>
      {props.errorText ? (
        <p className={style.errorMsg}>
          <svg
            width="19"
            height="18"
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.1998 12.4502C10.1998 12.0912 9.90879 11.8002 9.5498 11.8002H9.4502C9.09121 11.8002 8.8002 12.0912 8.8002 12.4502V12.5498C8.8002 12.9078 9.08966 13.1984 9.44764 13.1998L9.54725 13.2002C9.72009 13.2009 9.88607 13.1327 10.0085 13.0107C10.131 12.8887 10.1998 12.723 10.1998 12.5502V12.4502ZM10.15 5.4502C10.15 5.09121 9.85898 4.8002 9.5 4.8002C9.14102 4.8002 8.85 5.09121 8.85 5.4502V9.4502C8.85 9.80918 9.14102 10.1002 9.5 10.1002C9.85898 10.1002 10.15 9.80918 10.15 9.4502V5.4502ZM9.5 17.35C4.88842 17.35 1.15 13.6116 1.15 9C1.15 4.38842 4.88842 0.65 9.5 0.65C14.1116 0.65 17.85 4.38842 17.85 9C17.85 13.6116 14.1116 17.35 9.5 17.35Z"
              stroke="#FF376E"
              strokeWidth="1.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {props.errorText}
        </p>
      ) : null}
      {props.iconSearch ? (
        <span className={style.iconSearch}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.705 12.295L10.885 9.50001C11.5294 8.60272 11.9136 7.54493 11.9952 6.44323C12.0768 5.34152 11.8527 4.23868 11.3475 3.25623C10.8423 2.27378 10.0757 1.44988 9.13216 0.875327C8.1886 0.300773 7.10473 -0.00212657 6.00001 1.12383e-05C5.91501 1.12383e-05 5.83501 1.12383e-05 5.75001 1.12383e-05C5.66501 1.12383e-05 5.58501 1.12383e-05 5.50001 1.12383e-05C4.04132 1.12383e-05 2.64237 0.579474 1.61092 1.61092C0.579474 2.64237 1.12383e-05 4.04132 1.12383e-05 5.50001C1.12383e-05 5.58501 1.12383e-05 5.66501 1.12383e-05 5.75001C1.12383e-05 5.83501 1.12383e-05 5.91501 1.12383e-05 6.00001C-0.00212657 7.10473 0.300773 8.1886 0.875327 9.13216C1.44988 10.0757 2.27378 10.8423 3.25623 11.3475C4.23868 11.8527 5.34152 12.0768 6.44323 11.9952C7.54493 11.9136 8.60272 11.5294 9.50001 10.885L12.32 13.705C12.5113 13.8688 12.7574 13.9544 13.0091 13.9447C13.2607 13.935 13.4995 13.8307 13.6776 13.6526C13.8557 13.4745 13.96 13.2357 13.9697 12.9841C13.9794 12.7324 13.8938 12.4863 13.73 12.295H13.705ZM6.00001 10C5.20889 10 4.43553 9.76542 3.77773 9.32589C3.11993 8.88636 2.60724 8.26165 2.30449 7.53075C2.00174 6.79984 1.92253 5.99557 2.07687 5.21965C2.23121 4.44373 2.61217 3.73099 3.17158 3.17158C3.73099 2.61217 4.44373 2.23121 5.21965 2.07687C5.99557 1.92253 6.79984 2.00174 7.53075 2.30449C8.26165 2.60724 8.88636 3.11993 9.32589 3.77773C9.76542 4.43553 10 5.20889 10 6.00001C10 7.06088 9.57858 8.07829 8.82844 8.82844C8.07829 9.57858 7.06088 10 6.00001 10Z"
              fill="#460AF0"
            />
          </svg>
        </span>
      ) : null}
    </div>
  );
}

export default Input;
